import Vue from 'vue'
import Router from 'vue-router'
import Home from './layouts/Default.vue'
import store from './store'
import { AuthActionRefresh } from './store/action-types'

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Home,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          meta: { requiresAuth: true },
          component: () => import(/* webpackChunkName: "Dashboard" */ './views/Dashboard.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "Login" */ './views/Login.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.user.isLoggedIn) {
      store.dispatch<AuthActionRefresh>({
        type: 'auth/refresh',
        isLoginRoute: true,
        successCallback () {
          next()
        },
        failCallback () {
          next({
            name: 'Login'
          })
        }
      })
      return
    }
  }
  next()
})

export default router
